import { isEmpty, uniq } from 'lodash';
import { FocusTag, TagLabel } from 'shared/file-importer/types';

export const getUniqueFocusTags = (focusTags: FocusTag[] | undefined): string[] => {
    return uniq(focusTags?.map((tag) => tag.tagName));
};

export const getUniqueFocusLabels = (labels: (TagLabel | undefined)[]): string[] => {
    return uniq(labels?.filter((label) => !isEmpty(label))?.map((label) => label?.labelText ?? ''));
};

export const getRowStyle = () => {
    return { backgroundColor: 'var(--r-catapult-white)' };
};

export const cellStyle = () => {
    return { alignContent: 'center' };
};
